import * as React from 'react'
import {Box, Typography} from '@mui/material'
import {FONT, SIZE} from '../../../../styles/foundation/typography'
import {SUCCESS, BORDER, SUBTLE} from '../../../../styles/foundation/colors'
import {RADIUS} from '../../../../styles/foundation/spacing'
import {PRELIM_CYCLES} from './logic'

/**
 * Two 14x6 pills, one per preliminary billing cycle, filled SUCCESS once
 * elapsed. The pills are `aria-hidden` — pure decoration — because the
 * accessible content is the text next to them: a screen reader user must
 * never be left inferring "how many cycles elapsed" from colour alone.
 */
export default function RqCyclePips({cycles}) {
  const n = Math.max(0, Number(cycles) || 0)
  const pips = Array.from({length: PRELIM_CYCLES}, (_, i) => i + 1)

  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75}}>
      <Box aria-hidden='true' sx={{display: 'flex', gap: '3px'}}>
        {pips.map((i) => (
          <Box
            key={i}
            sx={{width: 14, height: 6, borderRadius: RADIUS.pill, bgcolor: i <= n ? SUCCESS : BORDER}}
          />
        ))}
      </Box>
      <Typography sx={{fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontVariantNumeric: 'tabular-nums'}}>
        {n} of {PRELIM_CYCLES} elapsed
      </Typography>
    </Box>
  )
}
